//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { loadGsap } from '@/utils/utils'

export default {
  props: {
    stop: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      locale: this.$i18n.locale || 'ru',
      gsapReady: !!window.gsap
      // locale: 'en'
    }
  },
  watch: {
    stop () {
      this.tl.pause()

      if (this.stop) {
        this.$emit('stop', this)
      }
    }
  },
  async mounted () {
    await loadGsap()

    this.tl = gsap.timeline({
      repeat: -1,
      yoyo: true,
      repeatDelay: 0.6,
      onRepeat: () => {
        this.tl.timeScale( 2 )
      }
    })

    this.tl.to('[data-step="1"]', { opacity: 1, duration: 0.06 })
    this.tl.to('[data-step="1"]', { opacity: 0, duration: 0.06 }, '+=0.6')
    this.tl.to('[data-step="2"]', { opacity: 1, duration: 0.06 }, '<')
    this.tl.to('[data-step="2"]', { opacity: 0, duration: 0.06 }, '+=0.58')
    this.tl.to('[data-step="3"]', { opacity: 1, duration: 0.06 }, '<')
    this.tl.to('[data-step="3"]', { opacity: 0, duration: 0.06 }, '+=0.5')
    this.tl.to('[data-step="4"]', { opacity: 1, duration: 0.06 }, '<')
    this.tl.to('[data-step="4"]', { opacity: 0, duration: 0.06 }, '+=0.4')
    this.tl.to('[data-step="5"]', { opacity: 1, duration: 0.06 }, '<')
    this.tl.to('[data-step="5"]', { opacity: 0, duration: 0.06 }, '+=0.2')
    this.tl.to('[data-step="6"]', { opacity: 1, duration: 0.06 }, '<')
    this.tl.to('[data-step="6"]', { opacity: 0, duration: 0.06 }, '+=0.2')
    this.tl.to('[data-step="7"]', { opacity: 0, duration: 0.06 }, '<')
    this.tl.to('[data-step="7"]', { opacity: 1, duration: 0.06 }, '+=0.2')
    this.tl.to('[data-step="8"]', { opacity: 1, duration: 0.06 }, '<')
  },
  beforeDestroy () {
    if (this.tl) {
      this.tl.kill()
    }
  }
}
